const autoCompletePlugin = {
    install: function (Vue, options) {
        Vue.directive('offautocomplete', {
            bind (el, binding, vnode) {                
                offautocomplete(el);
            }
        })

        Vue.directive('offallautocomplete', {
            // Notice: [Tim] [componentUpdated指自己元件更新完畢，要注意子元件可能尚未Updated]
            componentUpdated (el, binding, vnode) {                  
                offAllInput(el);
            }           
        })
    }
};

export function offAllInput(el){
    let all = el.getElementsByTagName("input");
    for (let i = 0; i < all.length; i++) {
        offautocomplete(all[i]);
    }
}

function offautocomplete(el){
    el.autocomplete='one-time-code';
}

export default autoCompletePlugin;